
import global from '@/assets/js/global'
const data = {}
// 数智人大
data.zhrdList = [
  { label: '机关办公平台', bgColor: '#6CA3F3', url: '', icon: 'icon-book' },
  { label: '人大立法工作管理平台', bgColor: '#AC917C', url: '', icon: 'icon-zhengcefagui2' },
  { label: '预决算公开平台', bgColor: '#AC917C', url: '', icon: 'icon-yijianfankui' },
  { label: '代表履职服务平台', bgColor: '#f56c6c', url: global.serviceUrl, icon: 'icon-tiaochawenjuan' },
  { label: '代表网上联络站', bgColor: '#f56c6c', url: '/liaisonStation', icon: 'icon-shujudaping' }
]
// 专题专栏
data.ztzlList = [
  { label: '区县人大', url: '/newList?navCode=45&navName=县区人大', imgUrl: global.imageUrl + '/dsxxjy.png' },
  { label: '联动监督', url: '/newList?navCode=33&navName=监督工作', imgUrl: global.imageUrl + '/ldjd.png' },
  { label: '中国共参党网', url: 'https://www.12371.cn/special/20da/', imgUrl: global.imageUrl + '/huazhang.png' }
]
// 互动交流
data.hdjlList = [
  // { label: '电子展馆', bgColor: '#f56c6c', url: 'https://dzzg.tsrd.gov.cn/?scene_id=70879615', icon: 'icon-shujudaping' },
  { label: '意见征集', bgColor: '#AC917C', url: '/newList?navCode=wzdh-yjzj&navName=意见征集', icon: 'icon-shoujianxiang' },
  // { label: '网上信访', bgColor: '#6CA3F3', url: '/lettersVisits', icon: 'icon-tiaochawenjuan' },
  { label: '问卷调查', bgColor: '#6CA3F3', url: '/newList?navCode=wzdh-wjdc&navName=问卷调查', icon: 'icon-zhengcefagui2' },
  // { label: '国家法律法规库', bgColor: '#6CA3F3', url: 'https://flk.npc.gov.cn', icon: 'icon-zhengcefagui2' },
  // { label: '地方性法规', bgColor: '#f56c6c', url: '/newList?navCode=39&navName=地方性法规', icon: 'icon-book' }
]
data.picLiList = [

  // { label: '人大制度研究会', url: '/jsyjhHome', imgUrl: global.imageUrl + '/rd2_1.png' },
  { label: '法律法规', url: '/newList?navCode=38&navName=法律法规', imgUrl: global.imageUrl + '/rd2_2.png' },
  // { label: '地方法规', url: '/newList?navCode=39&navName=地方法规', imgUrl: global.imageUrl + '/rd2_3.png' },
  { label: '规章制度', url: '/newList?navCode=40&navName=规章制度', imgUrl: global.imageUrl + '/rd2_4.png' },
  // { label: '理论研究', url: '/newList?navCode=44&navName=理论研究', imgUrl: global.imageUrl + '/rd2_5.png' },
  // { label: '历史沿革', url: '/newList?navCode=20&navName=历史沿革', imgUrl: global.imageUrl + '/rd2_6.png' },


  // { label: '理论研究', url: '/newList?navCode=44&navName=理论研究', imgUrl: global.imageUrl + '/rd2_1.png' },
  // { label: '廉政教育', url: '/newList?navCode=wzdh-lzjy&navName=廉政教育', imgUrl: global.imageUrl + '/rd2_2.png' },
  // { label: '唐山市人大<br />新闻奖评选', url: '/newList?navCode=wzdh-xwjpx&navName=新闻奖评选', imgUrl: global.imageUrl + '/rd2_3.png' },
  // { label: '精神文明建设', url: '/newList?navCode=wzdh-jswmjs&navName=精神文明建设', imgUrl: global.imageUrl + '/rd2_4.png' },
  // { label: '机关党建', url: '/newList?navCode=wzdh-jgdj&navName=机关党建', imgUrl: global.imageUrl + '/rd2_5.png' },
  // { label: '常委会会议', url: '/newList?navCode=23&navName=常委会公报', imgUrl: global.imageUrl + '/rd2_6.png' },
  // { label: '唐山市人大<br />制度理论研究会', url: '/newList?navCode=wzdh-zdllyjh&navName=制度理论研究会', imgUrl: global.imageUrl + '/rd2_7.png' },
  // { label: '国家安全<br />宣传教育', url: '/newList?navCode=wzdh-gjaqxcjy&navName=国家安全宣传教育', imgUrl: global.imageUrl + '/rd2_8.png' }
]



switch (global.tenantCode) {
  // 延津县
  case '410726000000000001':
    data.footerData = {
      organizer: '延津县人民代表大会常务委员会 ',
      address: '延津县平安大道2号',
      zipCode: '453200',
      icpText: '豫ICP备20007185号-1',
      icpHttp: 'https://beian.miit.gov.cn/',
      partyOrgan: 'https://bszs.conac.cn/sitename?method=show&id=A324251C9320F639E05310291AACE73E',
      publicSecurityText: '豫公网安备41072602000494号',
      publicSecurityHttp: 'https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41072602000494'
    }
    // data.zhurenLabel = "代理主任"
    break;
  // 原阳县
  case '410725000000000001':
    data.footerData = {
      organizer: '原阳县人大常委会',
      address: '原阳县黄河大道中段综合楼5楼',
      zipCode: '453500',
      icpText: '豫ICP备18016445号-1',
      icpHttp: 'https://beian.miit.gov.cn/',
      partyOrgan: 'https://bszs.conac.cn/sitename?method=show&id=A33AFBA6312342E4E05310291AAC5E5A',
      publicSecurityText: '豫公网安备 41072502000100号',
      publicSecurityHttp: 'https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41072502000100'
    }
    break;
  // 封丘县
  case '410727000000000001':
    data.footerData = {
      organizer: '封丘县人民代表大会常务委员会 ',
      address: '封丘县城关镇民主路108号',
      zipCode: '453300',
      icpText: '豫ICP备2022013589号-1',
      icpHttp: 'https://beian.miit.gov.cn/',
      partyOrgan: 'https://bszs.conac.cn/sitename?method=show&id=E5F26840FB56105AE05310291AAC2D40',
      publicSecurityText: '豫公网安备 41072702000246号',
      publicSecurityHttp: 'https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41072702000246'
    }
    break;

  default:
    break;
}
export default {
  data
}
